import * as React from 'react';
import { useQuery } from 'data-fetching-client';
import { GET_CHATFLOW_BY_ID } from 'flow-doctor-lib/queries/CrmObjectQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
const ChatflowNameLabel = ({
  portalId,
  chatflowId,
  showId = false
}) => {
  const {
    loading,
    error,
    data
  } = useQuery(GET_CHATFLOW_BY_ID, {
    variables: {
      portalId,
      chatflowId
    }
  });
  if (error) {
    return /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.references.chatflow.unknownChatflow",
        options: {
          chatflowId
        }
      })
    });
  }
  if (loading || !data) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  const name = data.chatflowById.results[0].properties.hs_chatflow_name.value;
  return /*#__PURE__*/_jsx("span", {
    children: showId ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: showId ? 'flow-doctor-lib.references.chatflow.labelWithId' : 'flow-doctor-lib.references.chatflow.label',
      options: {
        chatflowName: name,
        chatflowId
      }
    }) : name
  });
};
export default ChatflowNameLabel;